export default "__VITE_ASSET__de06b4d0__"